export function parseOutIPFSHash(input: string) {
  /**
   * If this is a URL, get everything after the last '/'
   * If the string ends with '/', strip that as well.
   */
  // input = /([^\/]+)\/*$/gi.exec(input)?.[1] ?? input;
  return input;
}
